'use client';
import Script from 'next/script';

export function CookieProScripts() {
  const script = process.env.NEXT_PUBLIC_COOKIEPRO_SCRIPT ?? '';
  return (
    <>
      <Script
        id="ot-sdk-stub"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-domain-script={script}
        strategy="beforeInteractive"
      ></Script>
      <Script
        id="optanon-wrapper"
        type="text/javascript"
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onReady={function OptanonWrapper() {}}
        strategy="beforeInteractive"
      ></Script>
    </>
  );
}
